import type { IconData } from '@stacksjs/iconify-core'

export const basicUiAdd: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M11 0H5v5H0v6h5v5h6v-5h5V5h-5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiAdd
